import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsUsers = {
  CREATE: '/v1/users',
  BY_USER: (id) => `/v1/users/${id}`,
  BY_USER_HR_INFO: (id) => `/v1/users/${id}/hrInfo`,
  BY_USER_JOB_INFO: (id) => `/v1/users/${id}/jobInfo`,
  BY_USER_PERSONAL_INFO: (id) => `/v1/users/${id}/personalInfo`,
  LOAD: (filter, sort, limit, skip) =>
    `/v1/users${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  LOAD_FUELSTATIONS: (filter, sort, limit, skip) =>
    `/v1/fuelStations/accessUsers${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  PROFILE: '/v1/users/myProfile',
  PROFILE_IMG: '/v1/users/myProfile/image',
}

export default endpointsUsers
